import { makeRootStyles } from "../../../theme/styles";

const itemStyles = {
  flexGrow: 1,
  display: "flex",
  justifyContent: "center",
};

const useStyles = makeRootStyles(
  {
    footer: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    buttonWrapper: {
      display: "flex",
      width: "100%",
      padding: "16px 24px",
      columnGap: "16px",
      rowGap: "8px",
      boxSizing: "border-box",
    },
    item: itemStyles,
    leftItem: {
      ...itemStyles,
      justifyContent: "end",
    },
    rightItem: {
      ...itemStyles,
      justifyContent: "start",
    },
    divider: {
      margin: 0,
      width: "100%",
      borderStyle: "none",
      borderWidth: 0,
    },
  },
  { name: "N0Footer" },
);

export { useStyles };
